import React from 'react';
import forwardRefAs from 'forward-ref-as';
import styles from './spinner.module.scss';
import { cn } from '../../helpers';

interface SpinnerProps {
    size?: 'sm' | 'md' | 'lg';
}

export const Spinner = forwardRefAs<'div', SpinnerProps>(
    ({ as: As = 'div', size = 'md', className, ...props }, ref) => {
        const spinnerClasses = cn(styles.spinner, { [className]: className });

        return <As ref={ref} className={spinnerClasses} {...props} />;
    }
);
